//import { GedApi } from "./configs/Api";
import {GedApiBack} from "./configs/Api";
import { AccessResponse, AccessSharepointListItem, GedSharepointListItem, WorkspaceResponse } from "../models/SharePointTypes";
import { MailContent } from "../models/MailNotifTypes";

export const GedService = {



  /**  DETAILS AND WORKSPACE */

  getContract: async function (projectId:number/*,userService:string*/) {
    const response = await GedApiBack.request({
        url: `/project?q=${projectId}&page=10`,
        method: "GET",
      })
    return response.data
  },

  requestProjectWorkspace: async function (projectId:number, data:GedSharepointListItem):Promise<WorkspaceResponse> {
    const response = await GedApiBack.request({
        url: `/project/${projectId}/workspace`,
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        data: data,
        body: 'raw'
       
      })
    return response.data
  },

  requestProjectAccess: async function (projectId:number, data:AccessSharepointListItem):Promise<AccessResponse> {

    const response = await GedApiBack.request({
        url: `/project/${projectId}/access`,
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        data: data,
        body: 'raw'
       
      })
    return response.data
  },
  
  getCodeSp: async function (serviceId:number) {
    const response = await GedApiBack.request({
      url: `/service-lookup/${serviceId}`,
      method: "GET",
    })
  return response.data
  },

  getUser: async function (name:string) {
    const response = await GedApiBack.request({
        url: `/user/search?name=${name}`,
        method: "GET",
      })
    return response.data
  },

  requestProjectUser: async function (mailcontent:MailContent){
    const response = await GedApiBack.request({
        url: `/mail/users`,
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        data: mailcontent
       
      })
    return response.data
  },
}
